enum RegisterContent {
  BIRTHDAY = 'BIRTHDAY',
  GENDER = 'GENDER',
  EMAIL = 'EMAIL',
  PHONE = 'PHONE',
  ACCEPT_PROMOTION = 'ACCEPT_PROMOTION',
}

export default RegisterContent;
